"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// src/jsx/Contact.tsx
function Contact(props) {
  return /* @__PURE__ */ React__namespace.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props
  }, /* @__PURE__ */ React__namespace.createElement("path", {
    fillRule: "evenodd",
    d: "M5.335 3.64a2.37 2.37 0 013.308.16l1.868 2.012a2 2 0 01.324 2.255l-.726 1.45a10.121 10.121 0 001.054 1.646c.813 1.032 2.02 2.148 3.7 2.743l.916-.572a2 2 0 012.507.316l1.951 2.047c.656.688.772 1.728.283 2.543-1.187 1.981-3.557 3.307-5.981 2.539-5.106-1.618-8.744-5.362-10.925-9.673-1.336-2.64-.333-5.647 1.721-7.467zM8.07 9.866a1 1 0 01.036-.814l.94-1.88L7.178 5.16a.37.37 0 00-.517-.025C5.121 6.502 4.566 8.558 5.4 10.203c1.992 3.939 5.254 7.247 9.744 8.67 1.328.42 2.825-.265 3.662-1.661a.112.112 0 00-.015-.135l-1.951-2.047-1.309.818a1 1 0 01-.808.113c-2.426-.702-4.089-2.239-5.13-3.561a12.125 12.125 0 01-1.144-1.743 7.605 7.605 0 01-.378-.789v-.001z",
    clipRule: "evenodd"
  }));
}
var Contact_default = Contact;

exports.Contact_default = Contact_default;
